/**
 * Delete Bank Dialog Component
 * 
 * Confirmation dialog for deleting bank.
 */

import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import type { Bank } from "@/services/bankService";

interface DeleteBankDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  bank: Bank | null;
  onConfirm: () => Promise<void>;
}

export function DeleteBankDialog({
  open,
  onOpenChange,
  bank,
  onConfirm,
}: DeleteBankDialogProps) {
  const [deleting, setDeleting] = React.useState(false);

  const handleConfirm = async () => {
    if (!bank) return;

    setDeleting(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch (error) {
      console.error("Error deleting bank:", error);
    } finally {
      setDeleting(false);
    }
  };

  if (!bank) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Hapus Bank?</AlertDialogTitle>
          <AlertDialogDescription>
            Apakah Anda yakin ingin menghapus bank <strong>{bank.name}</strong> ({bank.code})?
            Tindakan ini tidak dapat dibatalkan.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting}>Batal</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={deleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Hapus
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

